export const ROOT_URL = '/'
export const TERMS_URL = '/terms_and_conditions'
